export enum CreationMethod {
  AIRCALL_WEBHOOK = 'AIRCALL_WEBHOOK',
  LAPRO_UPLOAD = 'LAPRO_UPLOAD',
  MA_WIZARD = 'MA_WIZARD',
  MS_WIZARD = 'MS_WIZARD',
  NEWSLETTER = 'NEWSLETTER',
  WIZARD = 'WIZARD',
  CRM = 'CRM',
}
